export default __webpack_public_path__ + "static/password-reset-6934932c8bc1ccece5a61979f6f886e2.jpg";